<template>
    <div class="footer-box">
        <div class="container1">
            <div class="logo-box">
                <img class="logo" src="@/assets/img/logo0.png" @click="submit" />
            </div>
            <div class="left-right-box">
                <div class="left-box">
                    <ul class="right-ul" v-for="(item, key) in form.leftList" :key="key">
                        <itemAdd :list="form.leftList" :itemIndex="key"></itemAdd>
                        <li class="title" v-edit="{ form: item, key: 'title' }">{{ item.title }}</li>
                        <li class="text" v-for="(items, keys) in item.children" :key="keys">
                            <itemAdd :list="item.children" :itemIndex="keys"></itemAdd>
                            <span v-if="$store.state.token" v-edit="{ form: items, key: 'title' }">{{ items.title }}</span>
                            <span class="cursor" v-else @click="goToLink(items.path)">{{ items.title }}</span>
                        </li>
                    </ul>
                </div>
                <div class="right-box">
                    <div class="right-box-title" v-edit="{ form: form.rightTitle, key: 'title' }">{{ form.rightTitle }}</div>
                    <div class="right-box-ul">
                        <ul class="right-ul" v-for="(item, key) in form.rightList" :key="key">
                            <itemAdd :list="form.rightList" :itemIndex="key"></itemAdd>
                            <img :src="item.img" v-img="{ form: item, key: 'img' }" alt="" />
                            <li class="li-title" v-edit="{ form: item, key: 'title' }">{{ item.title }}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="tips-div">
                <p class="tip-text" style="margin: 0 auto">
                    Copyright @ 深圳数位大数据科技有限公司 All Rights Reserved
                    <a target="_blank" href="https://beian.miit.gov.cn/">粤ICP备15041214号</a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { updateById } from '../api/index';
import { pageQuery } from '../api/index';
import itemAdd from './item-add.vue';
export default {
    name: '',
    data() {
        return {
            form: {
                // leftList: [
                //     {
                //         title: '产品与服务',
                //         children: [
                //             { title: '上上参谋', path: '/superiorStaffHome' },
                //             { title: '上上参谋企业版', path: '/cloudHome' },
                //             { title: '数位观察', path: 'https://www.swguancha.com/' },
                //         ]
                //     },
                //     { title: '资讯中心', children: [
                //             { title: '公司动态', path: '/news' },
                //             { title: '活动新闻', path: '/news' },
                //             { title: '媒体报道', path: '/news' }
                //         ]
                //     },
                //     { title: '关于我们', children: [{ title: '数位简介', path: '/about' }] },
                //     { title: '联系方式', children: [{ title: '商务邮箱' }, { title: ' marketing@szshuwei.com ' }, { title: '  ' }, { title: '公司地址' }, { title: '深圳市南山区创维半导体设计大厦西座15F' }] }
                // ],
                // rightTitle: '深圳数位大数据科技有限公司',
                // rightList: [
                //     { title: '数位官方公众号', img: require('@/assets/img/qrCode_01.png') },
                //     { title: 'BD企业微信', img: require('@/assets/img/qrCode_02.png') }
                // ]
            }
        };
    },
    mounted() {
        this.getForm();
    },
    methods: {
        getForm() {
            pageQuery({ componentId: '166', current: 1, size: 10 }).then(res => {
                this.form = JSON.parse(res.data.data[0].context);
            });
        },
        goToLink(url) {
            if (!this.$store.state.token) {
                if (url.indexOf('http') === -1) {
                    this.$router.push(url);
                } else {
                    window.location.href = url;
                }
            }
        },
        submit() {
            if (this.$store.state.token) {
                let data = {
                    context: JSON.stringify(this.form),
                    refComponentId: 166,
                    id: 141,
                    type: 'PSwiper'
                };
                updateById(data).then(res => {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    location.reload();
                });
            }
        }
    },
    components: { itemAdd }
};
</script>

<style scoped lang="less">
@media screen and (max-width: 1540px) {
    .footer-box {
        .container1 {
            .right-box {
                margin-top: 25px;
            }

            .tips-div {
                .t-tip {
                    color: #999;
                    margin: 25px 30px 0 0 !important;
                }
            }
        }
    }
}
.footer-box {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    background-color: #000001;
    color: #fff;

    .container1 {
        .logo-box {
            width: 100%;
            height: 135px;
            display: flex;
            align-items: center;
            border-bottom: thin solid #1d1d1d;
            margin-bottom: 65px;
            @media @max-xs {
                margin-bottom: 60px;
            }
            .logo-icon {
                width: auto;
                height: 41px;
                object-fit: scale-down;
            }

            .logo {
                width: auto;
                height: 38px;
                object-fit: scale-down;
            }
        }

        .left-right-box {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            align-content: center;
            padding-bottom: 50px;
            border-bottom: thin solid #1d1d1d;
            @media @max-xs {
                padding-bottom: 60px;
            }
            .left-box {
                display: flex;
                flex-wrap: wrap;
                align-items: flex-start;
                @media @max-sm {
                    width: 100%;
                    justify-content: space-between;
                }
                @media @max-xs {
                    margin-bottom: -30px;
                }
                .right-ul {
                    min-width: 90px;
                    text-align: left;
                    > li {
                        margin: 0 40px;
                    }
                    @media @max-sm {
                        max-width: 20%;
                    }
                    @media @max-xs {
                        width: 50%;
                        max-width: 50%;
                        text-align: left;
                        margin-bottom: 30px;
                    }
                    .title {
                        color: #fff;
                        font-size: 18px;
                        margin-bottom: 22px;
                        white-space: nowrap;
                        font-family: 'PingFang-Heavy';
                    }

                    .text {
                        margin-bottom: 10px;
                        font-size: 16px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #8d8d8d;
                        line-height: 30px;
                        word-break: break-all;
                    }
                }
            }
            .right-box {
                .right-box-title {
                    font-size: 18px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #fefefe;
                    line-height: 72px;
                    margin-left: 9px;
                }
                .right-box-ul {
                    display: flex;
                    .right-ul {
                        margin: 0 9px;
                        display: flex;
                        align-items: center;
                        flex-direction: column;
                        > img {
                            width: 109px;
                            height: 109px;
                        }
                        .li-title {
                            height: 15px;
                            font-size: 16px;
                            font-family: Source Han Sans CN;
                            font-weight: 400;
                            color: #8d8d8d;
                            line-height: 30px;
                        }
                    }
                }
            }
        }

        .tips-div {
            padding: 30px 0px 30px 10px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            color: #999999;
            font-size: 14px;
            font-family: 'PingFang-Medium';
            a {
                color: #999;
            }
            .right-tips {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: center;

                .tip-text {
                    word-break: keep-all;
                }

                .t-tip {
                    color: #999;
                    margin: 0 10px 0 20px;
                }
            }
        }
    }
}
</style>
